import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoMessage16 = t0 => {
  const $ = _c(13);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M14.5 8C14.5 4.5625 11.9722 2.5 8 2.5C4.02778 2.5 1.5 4.5625 1.5 8C1.5 8.8912 2.11369 10.4037 2.20967 10.6348C2.21828 10.6555 2.22681 10.6745 2.23453 10.6955C2.30059 10.8757 2.57148 11.8351 1.5 13.2552C2.94445 13.9427 4.47844 12.8125 4.47844 12.8125C5.53975 13.3731 6.80253 13.5 8 13.5C11.9722 13.5 14.5 11.4375 14.5 8Z" strokeLinejoin="round" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== iconColor) {
    t3 = <path d="M4.5 8C4.5 8.27613 4.72386 8.5 5 8.5C5.27614 8.5 5.5 8.27613 5.5 8C5.5 7.72387 5.27614 7.5 5 7.5C4.72386 7.5 4.5 7.72387 4.5 8ZM7.5 8C7.5 8.27613 7.72387 8.5 8 8.5C8.27613 8.5 8.5 8.27613 8.5 8C8.5 7.72387 8.27613 7.5 8 7.5C7.72387 7.5 7.5 7.72387 7.5 8ZM10.5 8C10.5 8.27613 10.7239 8.5 11 8.5C11.2761 8.5 11.5 8.27613 11.5 8C11.5 7.72387 11.2761 7.5 11 7.5C10.7239 7.5 10.5 7.72387 10.5 8Z" fill={iconColor} />;
    $[3] = iconColor;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== iconColor || $[6] !== t3) {
    t4 = <g stroke={iconColor} strokeWidth={1.5} strokeLinecap="square">{t2}{t3}</g>;
    $[5] = iconColor;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ariaLabel || $[10] !== className || $[11] !== t4) {
    t6 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t4}{t5}</svg>;
    $[9] = ariaLabel;
    $[10] = className;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default IcoMessage16;